export default __webpack_public_path__ + "static/copper-flat-logo-7142a292261e1370096670401111b162.svg";